export default {
  trialLength: 7,
  trialGraceDays: 0,
  paidGraceDays: 1,
};
